import {useAuthStore} from '@/features/auth/store/store'
import {useAccountStore} from '../store/useAccountStore'
import {useEffect, useMemo} from 'react'

export const useEmailPendingVerification = () => {
    const authUser = useAuthStore()
    const emailVerificationStatus = useAccountStore(state => state.emailVerificationStatus)

    useEffect(() => {
        if (emailVerificationStatus == 'success' && !!authUser.user?.newEmailToVerify) {
            authUser.setAuthUser({
                ...authUser.user,
                email: authUser.user.newEmailToVerify,
                newEmailToVerify: null
            })
        }
    }, [emailVerificationStatus, authUser.user?.newEmailToVerify])

    const isPendingEmailVerification = useMemo(() => emailVerificationStatus == 'pending', [emailVerificationStatus])
    return isPendingEmailVerification
}
